let option = {
    // path where resources get loaded from, or a function
    // returning a path:
    // function(lngs, namespaces) { return customPath; }
    // the returned path will interpolate lng, ns if provided like giving a static path
    loadPath: '/locales/{{lng}}/{{ns}}.json',

    // path to post missing resources
    //addPath: 'locales/add/{{lng}}/{{ns}}',

    // your backend server supports multiloading
    // /locales/resources.json?lng=de+en&ns=ns1+ns2
    //allowMultiLoading: false,

    // parse data after it has been fetched
    // in example use https://www.npmjs.com/package/json5
    // here it removes the letter a from the json (bad idea)
    //parse: function(data) { return data.replace(/a/g, ''); },

    // allow cross domain requests
    crossDomain: false,

    // allow credentials on cross domain requests
    //withCredentials: false,

    // define a custom xhr function
    // can be used to support XDomainRequest in IE 8 and 9
    //ajax: function (url, options, callback, data) {}
};
export default option;


// WEBPACK FOOTER //
// ./src/i18next-backend.js